/* ErrorFrame.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./ErrorFrame.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { B200, N20A, N30A, N40A, N50A } from '@atlaskit/theme/colors';
export var Frame = function Frame() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
  };
  return props.compact ? /*#__PURE__*/React.createElement(CompactFrame, props) : /*#__PURE__*/React.createElement(ExpandedFrame, props);
};
var sharedBaseFrameStyles = null;
var sharedFrameStyles = null;
var expandedFrameHoverStyles = null;
var expandedFrameFluidHeightTrueStyles = null;
var expandedFrameFluidHeightFalseStyles = null;
var expandedFrameSelectedStyles = null;
var expandedFrameNotSelectedStyles = null;
var expandedFrameStyles = null;
export var ExpandedFrame = function ExpandedFrame(_ref) {
  var children = _ref.children,
    isSelected = _ref.isSelected,
    isHoverable = _ref.isHoverable,
    testId = _ref.testId,
    className = _ref.className,
    isFluidHeight = _ref.isFluidHeight;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: ax(["_1bsb1osq _1e0c1txw", "_p12fukw8 _bfhkhp5a", isHoverable && "_irr3uh3c _d0altlke", isFluidHeight ? "_1tkeidpf" : "_1tke68cl", isSelected ? "_2rkofajl _1h6d7a2i _1dqonqa1 _189e1dm9" : "_2rko1lya _1h6d1j28 _1dqonqa1 _189e1dm9", "_1reo15vq _18m915vq _1bah1yb4 _16qs1mq7", className]),
    "data-trello-do-not-use-override": testId,
    style: {
      "--_1irqcwi": ix("var(--ds-background-neutral-subtle-hovered, ".concat(N20A, ")")),
      "--_d9gj9p": ix("var(--ds-border-selected, ".concat(B200, ")")),
      "--_2wgsi3": ix("var(--ds-shadow-raised, ".concat("0 1px 1px ".concat(N50A, ", 0 0 1px 1px ").concat(N40A), ")"))
    }
  }, children);
};
var compactFrameHoverStyles = null;
var compactFrameInheritDimensionsTrueStyles = null;
var compactFrameInheritDimensionsFalseStyles = null;
var compactFrameAlignStyles = null;
var compactFrameStyles = null;
var compactFrameNotSelectedStyles = null;
export var CompactFrame = function CompactFrame(_ref2) {
  var children = _ref2.children,
    isHoverable = _ref2.isHoverable,
    isSelected = _ref2.isSelected,
    testId = _ref2.testId,
    className = _ref2.className,
    inheritDimensions = _ref2.inheritDimensions;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: ax(["_1bsb1osq _1e0c1txw", "_p12fukw8 _bfhkhp5a", isHoverable && "_irr3bfnf", isSelected && "_2rkofajl _1h6d7a2i _1dqonqa1 _189e1dm9", !isSelected && "_2rko1lya", "_1bah1h6o _4cvr1h6o _bfhkkq2v", inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp", "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq", className]),
    style: {
      "--_6j4ewu": ix("var(--ds-background-neutral-hovered, ".concat(N30A, ")")),
      "--_d9gj9p": ix("var(--ds-border-selected, ".concat(B200, ")")),
      "--_12ncegi": ix("var(--ds-background-neutral, ".concat(N20A, ")"))
    }
  }, children);
};